import React, {useState, useEffect, useLayoutEffect} from 'react';
import './ret.css';
import { useLocation, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { isMobile } from 'react-device-detect';

const Moon =()=>{
    const {way : jikap} = useParams();
    const neyong = useLocation();
    const [pac, setpac] = useState();
    const [momo, setmomo] = useState(neyong.state);
  

    useLayoutEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/maimai?single=${jikap}`).then(kip=>{setpac(kip.data)})
            .catch(err=>{ 
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
        fetch();
        window.scrollTo(0,0);
    
    },[jikap]);

    useEffect(()=>{
        const fetca = async()=>{
            const kakad = await axios.get(`/api/monja?single=${jikap}`).then(kp =>{setmomo(kp.data)}).catch(err=>{
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
        const fetka = async()=>{
            const forty = await axios.get(`/api/monjone?single=${jikap}`).then(kp =>{setmomo({...momo, hit : momo.hit+1})}).catch(err=>{
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
        
        if(neyong?.state == null || "undy"){
            fetca();
       
        }else{
            fetka();
          
            return;
        };
        document.title = momo?.title + " - 돌파공모";
    },[jikap]);

   useEffect(()=>{
            document.title = momo?.title;
        },[momo]);

    return(
        <>
        <div className={isMobile ? 'ssoom' : 'smodda'}>
        <p className='modda submod'>{momo?.title}</p>    
    
        <div className='sorok sokak' dangerouslySetInnerHTML={{__html:momo?.content}}></div>
        </div>

        <Link to="/jika" onClick={()=>window.history.replaceState({page : window.history.state.page},null,null)} className='haolei saole'><span className='morok'>목록</span></Link>
        {pac?.has !== null && <div className={isMobile ? 'svous' : 'vous'}><div className='vousy'><span className='vous2'>이전글</span><span className='vous3'><Link to={`/jika/${pac?.has}`} state="undy" className='haolei'>{pac?.hus}</Link></span></div></div>}
        {pac?.las !== null && <div className={isMobile ? 'svous' : 'vous'}><div className='vousy'><span className='vous2'>다음글</span><span className='vous3'><Link to={`/jika/${pac?.las}`} state="undy" className='haolei'>{pac?.lus}</Link></span></div></div>} 
        </>
    )

}

export default Moon;